function clearErrorsOn(element) {
    // Remove the red border on inputs...
    element.querySelectorAll('.border-red-500').forEach(el => el.classList.remove('border-red-500'));

    // Remove validation attributes...
    const attributesToRemove = [
        'data-invalid',
        'aria-invalid',
    ];

    attributesToRemove.forEach(attr => element.querySelectorAll(`[${attr}]`).forEach(el => el.removeAttribute(attr)));

    // Remove [data-flux-error]...
    element.querySelectorAll('[data-flux-error]').forEach(el => el.remove());
}

window.clearErrorsOn = clearErrorsOn;

export default clearErrorsOn;

